<template>
	<div class="pre-plaid">
		<stepper
			v-bind:steps="['Account', 'Cause', 'Preferences', 'Funding']"
			:currentStep="4"
		/>
		<screen type="blue" institution="true">
			<template slot="logo">
				<img
					class="header-logo"
					:src="cause.icon"
					:style="{
						padding: this.cause.type == 'group' && '5px',
						background: this.cause.type == 'group' && 'white'
					}"
				/>
			</template>
			<template slot="org_name">
				<p style="font-size: 16px; color: white; margin-top: 3px">
					{{ cause.name }}
				</p>
			</template>
			<template slot="header">
				<ui-header type="light">
					<h2 slot="title">Link Your Accounts</h2>
					<p style="line-height: 20px">
						RoundUp App links to your accounts so you can start
						rounding up for charity automatically.
					</p>
				</ui-header>
			</template>
			<img
				src="@/assets/favorite-tacos-charity.png"
				style="width: 100%"
			/>
			<div class="roundup-row">
				<img
					src="@/assets/plaid_logo.png"
					style="width: 100px; height: auto"
				/>
				<p
					style="
						border-left: 1px solid white;
						height: 100%;
						margin-left: 20px;
						text-align: left;
						padding-left: 20px;
					"
				>
					We’ve partnered with Plaid to make this process secure and
					protect your privacy.
				</p>
			</div>
			<ui-button
				color="clear-white"
				class="info-button"
				@click="showInfo = !showInfo"
			>
				<i
					class="fas fa-question-circle"
					style="margin-right: 10px"
				></i>
				How does this work?
			</ui-button>
			<div v-if="!linkToken">
				<ui-button loading="loading" color="white" disabled="true"
					>Link Accounts</ui-button
				>
			</div>
			<p v-else>
				<plaid-link
					v-if="!loading"
					v-bind="{
						publicKey,
						env,
						webhook,
						clientName,
						onSuccess,
						token: linkToken
					}"
				>
					Link Accounts
				</plaid-link>
				<ui-button v-else loading="loading" color="white"
					>Link Accounts</ui-button
				>
			</p>

			<div class="center mt-5">
				<p style="cursor: pointer" class="link" @click="this.skipStep">
					Skip For Now
				</p>
			</div>
		</screen>
		<modal v-model="showInfo" size="small">
			<h4 style="font-size: 20px">Authorize RoundUps</h4>
			<p>
				Through our integration with Plaid, you select your bank account
				or the bank that issued your credit card depending on which
				accounts you want to link. That could include (but is not
				limited to) the same account as your donation card.
				<br /><br />
				This process is completely automated to protect your privacy. We
				never have access to your financial credentials, and all
				information is protected by 256-bit encryption keys.
				<br /><br />
				If you do not link accounts for RoundUps, donations still work -
				you are simply charged your minimum goal each month.
			</p>
			<ui-button
				color="white"
				style="
					border: 1px solid #2553cd;
					display: flex;
					width: auto;
					height: 40px;
					border-radius: 20px;
					align-items: center;
					margin-right: 0;
					margin-left: auto;
					font-size: 16px;
				"
				@click="showInfo = !showInfo"
				>Close</ui-button
			>
		</modal>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

// eslint-disable-next-line no-unused-vars
import UiButton from '../../ui/Button'
import UiHeader from '../../ui/Header'
import PlaidLink from 'vue-plaid-link'
import Screen from '../../ui/Screen'
import Stepper from '../../ui/Stepper'
import Modal from '../../ui/Modal'

export default {
	name: 'pre-plaid-view',
	components: { UiHeader, Screen, PlaidLink, UiButton, Stepper, Modal },
	data() {
		return {
			publicKey: process.env.VUE_APP_PLAID_PUBLIC_KEY,
			env: process.env.VUE_APP_PLAID_ENV,
			webhook: process.env.VUE_APP_PLAID_WEBHOOK,
			clientName: 'RoundUp App',
			link: null,
			loading: false,
			linkToken: null,
			showInfo: false
		}
	},
	computed: {
		...mapGetters(['organizations', 'cause'])
	},
	methods: {
		...mapActions([
			'getHome',
			'attachLink',
			'finishSignup',
			'fetchLinkToken'
		]),
		next() {
			this.navigate(
				{
					name: 'card',
					params: {
						backRoute: 'pre-card',
						nextRoute: 'pre-accounts'
					}
				},
				'forward'
			)
		},
		onBack() {
			this.navigate({ name: 'mindonation' }, 'back')
		},
		skipStep() {
			window.analytics.track('roundup_skiped')
			localStorage.setItem('roundup_skip', true)
			this.finishSignup()
			this.$swal({
				title: 'Success',
				text: "You're all setup! Thanks for helping us turn pocket change into global change!",
				showCancelButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false
			}).then(() => {
				this.navigate({ name: 'home' })
				return
			})
		},
		onSuccess(token, metadata) {
			const params = {
				public_token: token,
				institution_id: metadata.institution.institution_id,
				institution_name: metadata.institution.name
			}
			this.loading = true
			this.attachLink(params)
				.then(() => {
					this.loading = false
					this.finishSignup()
					this.$swal({
						title: 'Success',
						text: "You're all setup! Thanks for helping us turn pocket change into global change!",
						showCancelButton: false,
						allowOutsideClick: false,
						allowEscapeKey: false
					}).then(() => {
						this.navigate({ name: 'home' })
						return
					})
				})
				.catch((error) => {
					this.loading = false
					if (error.message) {
						this.$swal('Error', error.message)
					} else {
						this.$swal(
							'Error',
							'Unable to link accounts. Please try again.'
						)
					}
				})
		}
	},
	mounted() {
		this.fetchLinkToken()
			.then((resp) => {
				this.linkToken = resp.link_token
			})
			.catch((error) => this.$swal('Error', error.message))
	}
}
</script>

<style lang="scss" scoped>
.pre-plaid {
	color: #fff !important;
	p {
		color: #fff !important;
	}
	.modal-body {
		h4 {
			color: $dark-grey;
		}
		p {
			color: $dark-grey;
		}
	}
}
.plaid-link-button {
	background: #fff;
	color: $navy;
}
</style>
